var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBook105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 106,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M50.625 24.875v56.25m0-56.25-41.25-11.25v56.25l41.25 11.25m0-56.25 41.25-11.25v56.25l-41.25 11.25"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--icon-decorative-coral)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M9.375 84.875v7.5h82.5v-7.5"
})));
export { SvgBook105 as ReactComponent };
export default __webpack_public_path__ + "93567e8f0def5ab37d04da127b0171de.svg";